import { useMutation, useQueryClient } from "@tanstack/react-query";

import { processResponse } from "Infrastructure/Api/ApiUtils";
import {
  getResourcePath,
  Resources,
} from "Infrastructure/Translations/Resources";
import { REGISTRATION_REQUESTS_QUERY_KEYS } from "RegistrationRequests/Api/Queries/queryKeys";
import { postRegistrationRequestResolve } from "RegistrationRequests/Api/registrationRequestApi";

export function useResolveRegistrationRequestMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponse(
      (registrationRequestID: string) =>
        postRegistrationRequestResolve(registrationRequestID),
      {
        translationPrefix: getResourcePath(
          Resources.ApiErrors.ResolveRegistrationRequest,
        ),
      },
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: REGISTRATION_REQUESTS_QUERY_KEYS.all,
      });
    },
  });
}
